import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) {
            // Reset for demo purposes
            return {
              minutes: 15,
              seconds: 0
            };
          }
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex flex-col items-center justify-center p-6 bg-blue-50/50 rounded-2xl border border-blue-100 max-w-md mx-auto" data-id="element-1">
      <div className="flex items-center gap-2 text-[#EF4444] font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-2">
        <Clock className="w-4 h-4" data-id="element-3" />
        <span data-id="element-4">Oferta por tiempo limitado</span>
      </div>

      <div className="flex items-center gap-4 text-5xl font-black text-gray-900 tabular-nums" data-id="element-5">
        <motion.div key={timeLeft.minutes} initial={{
        y: -10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} className="bg-white px-4 py-2 rounded-lg shadow-sm" data-id="element-6">
          {String(timeLeft.minutes).padStart(2, '0')}
        </motion.div>
        <span className="text-[#10B981] animate-pulse" data-id="element-7">:</span>
        <motion.div key={timeLeft.seconds} initial={{
        y: -10,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} className="bg-white px-4 py-2 rounded-lg shadow-sm" data-id="element-8">
          {String(timeLeft.seconds).padStart(2, '0')}
        </motion.div>
      </div>

      <div className="flex gap-16 mt-2 text-xs font-medium text-gray-500 uppercase tracking-widest" data-id="element-9">
        <span data-id="element-10">Minutos</span>
        <span data-id="element-11">Segundos</span>
      </div>
    </div>;
}